export const EXCEL_FILE_ACCEPT =
    '.xls,.xlsx,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

export const DEFAULT_EXCEL_TEMPLATE_FILE_NAME = 'excel-template.xlsx';

export function isExcelFile(file: File): boolean {
    const lowerCaseName = file.name.toLowerCase();

    return lowerCaseName.endsWith('.xlsx') || lowerCaseName.endsWith('.xls');
}
